import React, { useState } from "react";
import styled from "styled-components";
import { TransparentOverlay } from "../Filters/RangeModal";

interface SToopTipMsgBubble {
  direction?: "top" | "bottom";
  iconSize?: number;
  sMargin?: string;
  minWidth?: number;
}

interface ToolTipProps extends SToopTipMsgBubble {
  msg: string;
  noMsg?: boolean;
}

export default function ToolTip({
  direction,
  iconSize,
  msg,
  sMargin,
  minWidth,
  noMsg,
}: ToolTipProps) {
  const [click, setClick] = useState(false);

  return (
    <ToopTipWrapper>
      {click && (
        <>
          <ToopTipMsgContainer direction={direction} iconSize={iconSize}>
            {direction === "bottom" && (
              <ToopTipMsgBubbleTriangle direction={direction} />
            )}

            <ToopTipMsgBubble sMargin={sMargin} minWidth={minWidth}>
              <MsgText>{msg}</MsgText>
            </ToopTipMsgBubble>

            {direction === "top" && (
              <ToopTipMsgBubbleTriangle direction={direction} />
            )}
          </ToopTipMsgContainer>

          <TransparentOverlay onClick={() => setClick(false)} />
        </>
      )}

      <TooptipIcon
        iconSize={iconSize}
        className="material-symbols-outlined"
        onClick={() => {
          if (!noMsg) {
            setClick(true);
          }
        }}
      >
        help
      </TooptipIcon>
    </ToopTipWrapper>
  );
}

const ToopTipWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

const TooptipIcon = styled.span<SToopTipMsgBubble>`
  cursor: pointer;
  color: #858c97;
  font-size: ${({ iconSize }) => iconSize ?? 24}px;
`;

const ToopTipMsgContainer = styled.div<SToopTipMsgBubble>`
  position: absolute;
  z-index: 999999999999999999999 !important;
  top: ${({ direction, iconSize }) =>
    direction === "bottom" ? `${(iconSize ?? 24) + 4}px` : "auto"};
  bottom: ${({ direction, iconSize }) =>
    direction === "top" ? `${(iconSize ?? 24) + 4}px` : "auto"};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ToopTipMsgBubbleTriangle = styled.div<SToopTipMsgBubble>`
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: ${({ direction }) => (direction === "bottom" ? 8 : 0)}px solid
    #1f2e3d;
  border-top: ${({ direction }) => (direction === "top" ? 8 : 0)}px solid
    #1f2e3d;
`;

const ToopTipMsgBubble = styled.div<SToopTipMsgBubble>`
  min-width: ${({ minWidth }) => minWidth ?? 180}px;
  min-height: 57px;
  border-radius: 7px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #1f2e3d;
  padding: 12px;
  margin: ${({ sMargin }) => sMargin ?? 0};
`;

const MsgText = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  color: #fefffe;
  word-break: keep-all;
  white-space: pre-line;
`;
